// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__RDdWh","iconDownload":"button_iconDownload__f76HR"};